import autobind from 'autobind-decorator';
import * as React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import styled, { css } from 'styled-components';

const Thumb = styled.div<any>`
  background-color: ${(p) => p.theme.color.disabled};
  border-radius: 5px;
  cursor: pointer;
  transition: 0.1s linear;
  &:hover {
    background-color: ${(p) => p.theme.color.gray};
  }
`;

interface ScrollbarsWrapper {
  view: HTMLDivElement;
  getScrollTop: () => number;
  scrollTop: (top: number) => void;
  scrollLeft: (left: number) => void;
  getScrollLeft: () => number;
}

export default class ColoredScrollbars extends React.Component<any, { top: number, scrollTop: number }, any> {
  public scrollbarRef = React.createRef<ScrollbarsWrapper>();

  constructor(props: any) {
    super(props);
    this.state = { top: 0, scrollTop: 0 };

    if (props.sendApi) {
      props.sendApi({
        setScrollTop: this.setScrollTop,
        getScrollTop: this.getScrollTop,
        getScrollLeft: this.getScrollLeft,
        setScrollLeft: this.setScrollLeft,
        getScrollHeight: this.getScrollHeight,
      });
    }
  }


  render(): JSX.Element {
    const { scrollevent = () => { }, ...rest } = this.props;
    return (
      <Scrollbars
        onMouseDown={this.stopEvent}
        ref={this.scrollbarRef}
        renderView={this.renderView}
        renderThumbHorizontal={this.renderThumb}
        renderThumbVertical={this.renderThumb}
        onUpdate={this.handleUpdate}
        // eslint-disable-next-line react/jsx-no-bind
        onScroll={() => scrollevent(this.state.scrollTop)}
        autoHide={true}
        {...rest}
      />
    );
  }

  @autobind
  private handleUpdate(values: { top: number, scrollTop: number }): void {
    const { top, scrollTop } = values;
    this.setState({ top, scrollTop });
  }

  @autobind
  // eslint-disable-next-line @typescript-eslint/typedef
  private renderView({ style, ...props }): JSX.Element {
    return <div style={{ ...style }} {...props} />;
  }

  @autobind
  // eslint-disable-next-line @typescript-eslint/typedef
  private renderThumb({ style, ...props }): JSX.Element {
    return (<Thumb
      style={{ ...style }}
      {...props}
      onClick={this.stopEvent}
    />);
  }

  @autobind
  private getScrollHeight(): number {
    if (this.scrollbarRef.current) {
      return this.scrollbarRef.current.view.getBoundingClientRect().height;
    }
    return 0;
  }

  @autobind
  private setScrollTop(top: any): void {
    if (this.scrollbarRef.current) {
      if (this.props.withSmoothScroll) {
        this.scrollbarRef.current.view.scrollTo({ top, behavior: 'smooth' });
      } else {
        this.scrollbarRef.current.scrollTop(top);
      }
    }
  }

  @autobind
  private getScrollLeft(): number {
    if (this.scrollbarRef.current) {
      return this.scrollbarRef.current.getScrollLeft();
    }
    return 0;
  }

  @autobind
  private setScrollLeft(left: number): void {
    if (this.scrollbarRef.current) {
      if (this.props.withSmoothScroll) {
        this.scrollbarRef.current.view.scrollTo({ left, behavior: 'smooth' });
      } else {
        this.scrollbarRef.current.scrollTop(left);
      }
    }
  }


  @autobind
  private getScrollTop(): number {
    if (this.scrollbarRef.current) {
      return this.scrollbarRef.current.getScrollTop();
    }
    return 0;
  }

  private stopEvent(e: MouseEvent): void {
    e.stopPropagation();
  }
}

export const webKitScrollbar = css`
  overflow: auto;
  &::-webkit-scrollbar {
    border-radius: 5px;
    &:vertical {
      width: 5px;
    }

    &:horizontal {
      height: 5px;
    }

    &-thumb {
      border-radius: 3px;
      background-color: ${(p) => p.theme.color.disabled};
    }

    &-track {
      background-color: transparent;
    }

    &-corner {
      background-color: transparent;
    }
  }

  :hover {
    &::-webkit-scrollbar {
      &-thumb {
        background-color: ${(p) => p.theme.color.gray};
      }
    }
  }
`;
